module.exports = __webpack_public_path__ + "media/src/images/payment_systems/invoice_de-3568183ed61e997ade420ee057e1f07f.png";